export default __webpack_public_path__ + "static/media/ps_section_3_1.ef7a5835.svg";